import { INewCardsLocalStorage, NEW_CARD_LOCALSTORAGE } from '../types';

export const getNewCardsLocalStorage = (
): INewCardsLocalStorage => {
    const data = localStorage.getItem(NEW_CARD_LOCALSTORAGE);
    return data ? JSON.parse(data) : {};
}
